import React, {useState} from 'react';
import { connect } from 'react-redux';
import { useCookies } from 'react-cookie';
import {cookies_string} from '../../../config.js';
import { Login } from '../../../actions/actions.js';
import { useNavigate, useLocation } from 'react-router-dom';
import HomeSvg from '../../../svg/menu/Home.js';
import MissionsSvg from '../../../svg/menu/Missions.js';
import ResultsSvg from '../../../svg/menu/Results.js';
import UsersSvg from '../../../svg/menu/Users.js';
import FaqSvg from '../../../svg/menu/Faq.js';
import PersonalInfoSvg from '../../../svg/menu/PersonalInfo.js';
import LogoutSvg from '../../../svg/menu/Logout.js';

function Component(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const [ __, _, removeCookie] = useCookies([`${cookies_string}_cred`,`${cookies_string}_token`]);
    const [isShowMenu,setisShowMenu]=useState(false)
	const handleLogout=()=>{
		props.dispatch(Login(false))
        removeCookie(`${cookies_string}_token`,'/')
        removeCookie(`${cookies_string}_cred`,'/')   
	}
    const toggleMenu=()=>{setisShowMenu(!isShowMenu)}
    const handleRoute=(route)=>()=>{
        navigate(`/platform/${route}`);
    }
    return(
        <div className='flex flex-col justify-between items-center p-[16px] bg-[#F2F2F2] h-full' style={{borderRight:'1px solid #D7D7D7',overflowY:'auto'}}>
            <div className='flex flex-col items-stretch gap-[16px] flex-1' style={{overflowY:"auto"}}>
                <div onClick={handleRoute('')}className='cursor-pointer flex flex-row items-center bg-[#FFFFFF] rounded-[10px] p-[16px] gap-[8px]' style={{opacity:['','/','/home'].includes(location.pathname.split('/')[2])?1:.5}}>
                    <HomeSvg/>
                    <div className='text-[20px] font-[700] flex-1 text-center' style={{color:['','home'].includes(location.pathname.split('/')[2])?"#43528A":'#727272'}}>首頁</div>
                </div>
                <div onClick={handleRoute('registrations')} className='cursor-pointer flex flex-row items-center bg-[#FFFFFF] rounded-[10px] p-[16px] gap-[8px]' style={{opacity:['registrations'].includes(location.pathname.split('/')[2])?1:.5}}>
                    <PersonalInfoSvg/>
                    <div className='text-[20px] font-[700] flex-1 text-center' style={{color:['registrations'].includes(location.pathname.split('/')[2])?"#43528A":'#727272'}}>學校登記管理</div>
                </div>
                <div onClick={handleRoute('missions')} className='cursor-pointer flex flex-row items-center bg-[#FFFFFF] rounded-[10px] p-[16px] gap-[8px]' style={{opacity:['missions'].includes(location.pathname.split('/')[2])?1:.5}}>
                    <MissionsSvg/>
                    <div className='text-[20px] font-[700] flex-1 text-center' style={{color:['missions'].includes(location.pathname.split('/')[2])?"#43528A":'#727272'}}>閲讀任務管理</div>
                </div>
                <div onClick={handleRoute('results')} className='cursor-pointer flex flex-row items-center bg-[#FFFFFF] rounded-[10px] p-[16px] gap-[8px]' style={{opacity:['results'].includes(location.pathname.split('/')[2])?1:.5}}>
                    <ResultsSvg/>
                    <div className='text-[20px] font-[700] flex-1 text-center' style={{color:['results'].includes(location.pathname.split('/')[2])?"#43528A":'#727272'}}>任務結果數據</div>
                </div>
                <div onClick={handleRoute('questionnaires')} className='cursor-pointer flex flex-row items-center bg-[#FFFFFF] rounded-[10px] p-[16px] gap-[8px]' style={{opacity:['questionnaires'].includes(location.pathname.split('/')[2])?1:.5}}>
                    <ResultsSvg/>
                    <div className='text-[20px] font-[700] flex-1 text-center' style={{color:['questionnaires'].includes(location.pathname.split('/')[2])?"#43528A":'#727272'}}>問卷數據</div>
                </div>
                <div onClick={handleRoute('users')} className='cursor-pointer flex flex-row items-center bg-[#FFFFFF] rounded-[10px] p-[16px] gap-[8px]' style={{opacity:['users'].includes(location.pathname.split('/')[2])?1:.5}}>
                    <UsersSvg/>
                    <div className='text-[20px] font-[700] flex-1 text-center' style={{color:['users'].includes(location.pathname.split('/')[2])?"#43528A":'#727272'}}>學校帳戶資料</div>
                </div>
                <div onClick={handleRoute('faq')} className='cursor-pointer flex flex-row items-center bg-[#FFFFFF] rounded-[10px] p-[16px] gap-[8px]' style={{opacity:['faq'].includes(location.pathname.split('/')[2])?1:.5}}>
                    <FaqSvg/>
                    <div className='text-[20px] font-[700] flex-1 text-center' style={{color:['faq'].includes(location.pathname.split('/')[2])?"#43528A":'#727272'}}>常見問題</div>
                </div>
            </div>

            <div onClick={handleLogout} className='w-full cursor-pointer flex flex-row justify-center items-center bg-[#FFFFFF] rounded-[10px] p-[16px] gap-[20px] mt-[16px]'>
                <LogoutSvg/>
                <div className='text-[20px] font-[700] text-center' style={{color:'black'}}>登出</div>
            </div>
        </div>
    )
}
export default connect((store)=>{
    return{
      token:store.tokenReducer,
    }
  })(Component)